/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, MDBBreadcrumb, MDBBreadcrumbItem, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../../Component/Pagination/Pagination'
import {Checkbox, message} from 'antd'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import $ from 'jquery'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'
import Select from 'react-select'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import AutoComplete from '../BaseComponent/autocomplete'

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class OrderList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      detailSort: false,
      providerId: '',
      list: [],
      error: '',
      location: [],
      orderStatus: [],
      showTable: false,
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      modalEdit: false,
      modalDetails: false,
      detailsList: [],
      selectedOption: [],
      fromDate: '',
      toDate: '',
      printInfo: [],
      buttonClicked: false,
      today: moment(),
      defaultValueDate: true,
      operatorId: '',
      changedTimeStampMin: '',
      changedTimeStampMax: '',
      operators: [],
      deliveryBehaviours: []
    }
  }

  epochFrom1 = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }
  epochTo1 = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    if (n >= 0) {
      return toEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return toEpoch - 3.5 * 3600 * 1000
    } else {
      return toEpoch - 3.5 * 3600 * 1000
    }
  }

  loadEditOrderStatus = (numRow, hasUnmatch, showEdit) => {
    let initialDeliveryTimeStamp = this.state.list[numRow].initialDeliveryTimeStamp
    let supplierName = this.state.list[numRow].supplierName == null ? '' : this.state.list[numRow].supplierName
    let visitorName = this.state.list[numRow].visitorName == null ? '' : this.state.list[numRow].visitorName
    let visitorPhone =
      this.state.list[numRow].phoneNumber == null ? '' : this.convertDigit(this.state.list[numRow].phoneNumber)
    let intOrderDeliveryLocationId = this.state.list[numRow].orderDeliveryLocationId
    let intOrderStatusId = hasUnmatch === 'true' ? 6 : 5
    let masterComment = this.state.list[numRow].orderComment === null ? '' : this.state.list[numRow].orderComment
    let comment =
      masterComment + '\n' + (localStorage.getItem('clipText') == null ? '' : localStorage.getItem('clipText'))
    let orderId = this.state.list[numRow].orderId
    sessionStorage.setItem('initialDeliveryTimeStampDto', initialDeliveryTimeStamp)
    sessionStorage.setItem('orderIdDto', orderId)
    sessionStorage.setItem('supplierNameDto', supplierName)
    sessionStorage.setItem('visitorNameDto', visitorName)
    sessionStorage.setItem('visitorPhoneDto', visitorPhone)
    sessionStorage.setItem('intOrderDeliveryLocationIdDto', intOrderDeliveryLocationId)
    sessionStorage.setItem('intOrderStatusIdDto', intOrderStatusId)
    sessionStorage.setItem('commentDto', comment)
    this.setState(
      {
        orderId: orderId,
        modalEdit: showEdit ? true : false
      },
      () => {}
    )
  }

  getByQuery = (providerId, hasUnmatch, date, showEdit) => {
    let filter = {
      pageNumber: 1,
      pageSize: 10,
      export: false,
      supplierId: providerId,
      fromTime: this.epochFrom1(date),
      toTime: this.epochTo1(date)
    }
    http
      .get(`${ORDER_STATUS.ORDERS_STATUS_ORDER_VIEW}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState(
            {
              list: response.data.object.result,
              showTable: true,
              lengthList: response.data.object.countAll,
              toPrintDate: this.state.today == '' ? '-' : jMoment(this.state.today).format('jYY/jMM/jDD'),
              fromPrintDate: this.state.today == '' ? '-' : jMoment(this.state.today).format('jYY/jMM/jDD'),
              buttonClicked: true
            },
            () => {
              if (this.state.list.length === 1) {
                this.loadEditOrderStatus(0, hasUnmatch, showEdit)
              }
            }
          )
        } else {
          message.error(response.data.description)
          $('.showBaseTable').fadeOut()

          this.setState({
            showTable: false,
            list: []
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  getAllOrderStatusList = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    sortBy = sessionStorage.getItem('sortBy')
  ) => {
    http
      .get(
        `${
          ORDER_STATUS.ORDERS_STATUS_ORDER_VIEW
        }?export=false&pageSize=${pageSize}&pageNumber=${pageNumber}&${params}&sortBy=${sortBy}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            list: response.data.object.result,
            showTable: true,
            lengthList: response.data.object.countAll,
            toPrintDate: this.state.today == '' ? '-' : jMoment(this.state.today).format('jYY/jMM/jDD'),
            fromPrintDate: this.state.today == '' ? '-' : jMoment(this.state.today).format('jYY/jMM/jDD'),
            buttonClicked: true
          })
        } else {
          // message.error(response.data.description);
          $('.showBaseTable').fadeOut()
          this.setState({
            showTable: false,
            list: []
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    http.get(`report/retail/list/delivery-behaviour`, {}).then((response) => {
      if (response.data.error == null) {
        let result = response.data.object
        for (let i = 0; i < result.length; i++) {
          result[i]['value'] = result[i].deliveryBehaviourId
          result[i]['label'] = result[i].name
        }
        this.setState({
          deliveryBehaviours: result
        })
      }
    })

    // http
    //   .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
    //   .then((response) => {
    //     if (response.data.error == null) {
    //       var result = response.data.object;
    //       for (let i = 0; i < result.length; i++) {
    //         result[i]["value"] = result[i].providerId;
    //         result[i]["label"] =
    //           "" + result[i].providerId + " - " + result[i].title;
    //       }

    //       this.setState({
    //         providers: response.data.object,
    //       });
    //     }
    //     // alert(JSON.stringify(response.data))
    //   })
    //   .catch((error) => {
    //     alert(JSON.stringify(error));
    //   });

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].personId
            result[i]['label'] = '' + result[i].personId + ' - ' + result[i].name
          }

          this.setState({
            operators: response.data.object
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '200')
    sessionStorage.setItem('sortBy', 'orderStatusSortOrder_asc,initialDeliveryTimeStamp_desc')
    sessionStorage.setItem(
      'params',
      `fromTime=${this.epochFrom(this.state.today)}&toTime=${this.epochTo(this.state.today)}`
    )

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    http
      .get(`${ORDER_STATUS.ORDERS_STATUS_ORDERDELIVERYLOCATION_LIST}`, {})
      .then((response) => {
        if (response.data.error == null && !(response.data.object == null)) {
          this.setState({
            location: response.data.object
          })
        } else if (response.data.error == null && response.data.object == null) {
          message.warning('در جدول پایه "محل تحویل" مقدار دهی اولیه انجام نشده است', 5)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http
      .get(`${ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_LIST}`, {})
      .then((response) => {
        if (response.data.error == null && !(response.data.object == null)) {
          this.setState({
            orderStatus: response.data.object
          })
        } else if (response.data.error == null && response.data.object == null) {
          message.warning('در جدول پایه "وضعیت" مقدار دهی اولیه انجام نشده است', 5)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    var urlParams = new URLSearchParams(window.location.search)
    var providerId = urlParams.get('providerId') === null ? '' : urlParams.get('providerId')
    var hasUnmatch = urlParams.get('hasUnmatch') === null ? '' : urlParams.get('hasUnmatch')
    var date = urlParams.get('date') === null ? '' : urlParams.get('date')
    if (!(providerId === '' && hasUnmatch === '' && date === '')) {
      this.setState(
        {
          defaultValueDate: false
        },
        () => {
          this.getByQuery(providerId, hasUnmatch, date, 'showEdit')
        }
      )
    } else {
      this.getAllOrderStatusList()
    }
  }

  handleDateChangeFrom = (date) => {
    this.setState({selectedDateFrom: date, selectedDateTo: date})
    // this.toDateInput.focus();
  }

  handleDateChangeTo = (date) => {
    this.setState({selectedDateTo: date})
    // this.toDateInput.focus();
  }
  submit(e) {
    e.preventDefault()
  }

  showDetails = (numId) => {
    var id = numId
    http
      .get(`${ORDER_STATUS.ORDERS_STATUS_ORDERDETAIL_VIEW}?orderId=${id}&sortBy=changedTimeStamp_desc`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null && !(response.data.object.result == null)) {
          $(function() {
            $('#errorEdit').hide()
          })
          this.setState({
            modalDetails: !this.state.modalDetails
          })
          this.setState({
            detailsList: response.data.object.result
          })
        } else if (response.data.error == null && response.data.object.result == null) {
          $(function() {
            $('#errorEdit').show()
          })

          this.setState({
            detailsList: [],
            modalDetails: !this.state.modalDetails
          })
        } else {
          message.error(response.data.error)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  details = () => {
    this.setState({
      modalDetails: !this.state.modalDetails
    })
  }
  closeDetails = () => {
    this.setState({
      modalDetails: !this.state.modalDetails
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  epochFrom = (x) => {
    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  onResultFetched(data) {
    this.setState({
      list: data
    })
  }

  Edit = (numRow) => {
    let initialDeliveryTimeStamp = this.state.list[numRow].initialDeliveryTimeStamp
    let supplierName = this.state.list[numRow].supplierName == null ? '' : this.state.list[numRow].supplierName
    let visitorName = this.state.list[numRow].visitorName == null ? '' : this.state.list[numRow].visitorName
    let visitorPhone =
      this.state.list[numRow].phoneNumber == null ? '' : this.convertDigit(this.state.list[numRow].phoneNumber)
    let intOrderDeliveryLocationId = this.state.list[numRow].orderDeliveryLocationId
    let intOrderStatusId = this.state.list[numRow].orderStatusId
    let comment = this.state.list[numRow].orderComment == null ? '' : this.state.list[numRow].orderComment
    let orderId = this.state.list[numRow].orderId
    sessionStorage.setItem('initialDeliveryTimeStampDto', initialDeliveryTimeStamp)
    sessionStorage.setItem('orderIdDto', orderId)
    sessionStorage.setItem('supplierNameDto', supplierName)
    sessionStorage.setItem('visitorNameDto', visitorName)
    sessionStorage.setItem('visitorPhoneDto', visitorPhone)
    sessionStorage.setItem('intOrderDeliveryLocationIdDto', intOrderDeliveryLocationId)
    sessionStorage.setItem('intOrderStatusIdDto', intOrderStatusId)
    sessionStorage.setItem('commentDto', comment)
    this.setState({
      modalEdit: !this.state.modalEdit,
      orderId: orderId
    })
  }

  EditCancel = () => {
    sessionStorage.removeItem('initialDeliveryTimeStampDto')
    sessionStorage.removeItem('supplierNameDto')
    sessionStorage.removeItem('visitorNameDto')
    sessionStorage.removeItem('visitorPhoneDto')
    sessionStorage.removeItem('orderIdDto')
    sessionStorage.removeItem('intOrderDeliveryLocationIdDto')
    sessionStorage.removeItem('intOrderStatusIdDto')
    sessionStorage.removeItem('commentDto')
    this.setState({
      modalEdit: !this.state.modalEdit
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    let pageSize = sessionStorage.getItem('dropDownVal')
    // sessionStorage.setItem('dropDownVal', '200');
    var providerFilter = this.state.providerId
    var locationIdFilter = $('#locationIdFilter').val()
    var orderStatusId = $('#orderStatusId').val()
    var visitorNameFilter = $('#visitorNameFilter').val()
    var mobileFilter = $('#mobileFilter').val()
    var description = $('#description').val()
    var deliveryBehaviourId = $('#deliveryBehaviourId').val()

    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let detailSort = this.state.detailSort ? true : ''
    let changedTimeStampMin = this.state.changedTimeStampMin
    let changedTimeStampMax = this.state.changedTimeStampMax

    let operatorId =
      this.state.operatorId === null || this.state.operatorId === '' ? '' : this.state.operatorId.personId

    if (
      deliveryBehaviourId === '' &&
      changedTimeStampMin === '' &&
      changedTimeStampMax === '' &&
      operatorId === '' &&
      minDate === '' &&
      (maxDate === '') & (providerFilter === '') &&
      locationIdFilter === '' &&
      orderStatusId === '' &&
      visitorNameFilter === '' &&
      mobileFilter === '' &&
      description === ''
    ) {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      sessionStorage.setItem(
        'params',
        `deliveryBehaviourId=${deliveryBehaviourId}&operatorId=${operatorId}&changedTimeStampMin=${changedTimeStampMin}&changedTimeStampMax=${changedTimeStampMax}&fromTime=${minDate}&toTime=${maxDate}&phoneNumber=${mobileFilter}&orderComment=${description}&visitorName=${visitorNameFilter}&supplierId=${providerFilter}&deliveryLocationId=${locationIdFilter}&orderStatusId=${orderStatusId}&detailSort=${detailSort}`
      )
      sessionStorage.setItem('sortBy', 'orderStatusSortOrder_asc,initialDeliveryTimeStamp_desc')
      this.getAllOrderStatusList()
    }
  }

  exportExcel = () => {
    http
      .get(
        `${ORDER_STATUS.ORDERS_STATUS_ORDER_VIEW}?export=true&${sessionStorage.getItem(
          'params'
        )}&sortBy=${sessionStorage.getItem('sortBy')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['initialDeliveryTimeStamp'] = jMoment(excelReport[i]['initialDeliveryTimeStamp']).format(
              'jYY/jMM/jDD HH:mm'
            )
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(
        `${ORDER_STATUS.ORDERS_STATUS_ORDER_VIEW}?export=true&${sessionStorage.getItem(
          'params'
        )}&sortBy=${sessionStorage.getItem('sortBy')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response))
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        } else {
          this.setState({
            printInfo: []
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  EditOk() {
    var supplierNameDto = sessionStorage.getItem('supplierNameDto')
    var visitorNameDto = document.getElementById('input_visitorName').value
    var visitorPhoneDto = document.getElementById('input_visitorPhone').value
    var intOrderDeliveryLocationIdDto = document.getElementById('input_orderDeliveryLocationId').value
    var intOrderStatusIdDto = document.getElementById('input_orderStatusId').value
    var commentDto = document.getElementById('input_comment').value
    var orderIdDto = this.state.orderIdDto

    let formError = false
    let supError = false
    let locError = false
    var mobileError = false
    let statusError = false

    if (supplierNameDto == '') {
      formError = true
      supError = true
      message.error('نام تامین کننده را وارد کنید')
    } else {
      if (!supError) {
        this.setState({
          error: ''
        })
      }
    }

    if (intOrderDeliveryLocationIdDto == '') {
      formError = true
      locError = true
      message.error('محل تحویل را مشخص کنید')
    } else {
      if (!locError) {
        this.setState({
          error: ''
        })
      }
    }
    if (intOrderStatusIdDto == '') {
      formError = true
      statusError = true
      message.error('وضعیت را مشخص کنید')
    } else {
      if (!statusError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!(visitorPhoneDto == '') && !visitorPhoneDto.match(/^09\d{9}$/g)) {
      mobileError = true
      formError = true
      message.error('موبایل را صحیح وارد کنید.مثال : 09124444444')
    } else {
      if (!mobileError) {
        this.setState({error: ''})
      }
    }

    if (!formError) {
      var data = {
        orderId: this.state.orderId,
        deliveryLocationId: intOrderDeliveryLocationIdDto,
        visitorName: visitorNameDto == '' ? undefined : visitorNameDto,
        phoneNumber: visitorPhoneDto == '' ? undefined : visitorPhoneDto,
        orderStatusId: intOrderStatusIdDto,
        orderComment: commentDto == '' ? undefined : commentDto
      }

      if (this.state.orderId) {
        http
          .post(`${ORDER_STATUS.ORDERS_STATUS_ORDER_UPDATE}`, data, {})
          .then((response) => {
            if (response.data.error == null && response.data.object == 'SUCCESS') {
              message.success('سفارش مورد نظر ویرایش شد')
              this.setState({
                modalEdit: false
              })

              var urlParams = new URLSearchParams(window.location.search)
              var providerId = urlParams.get('providerId') === null ? '' : urlParams.get('providerId')
              var hasUnmatch = urlParams.get('hasUnmatch') === null ? '' : urlParams.get('hasUnmatch')
              var date = urlParams.get('date') === null ? '' : urlParams.get('date')
              if (!(providerId === '' && hasUnmatch === '' && date === '')) {
                this.setState(
                  {
                    defaultValueDate: false
                  },
                  () => {
                    this.getByQuery(providerId, hasUnmatch, date)
                  }
                )
              } else {
                this.getAllOrderStatusList()
              }
            } else {
              message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            }
          })
          .catch((error) => {
            alert(JSON.stringify(error))
          })
      } else {
        message.error('شناسه وضعیت سفارش ارسال نشده است')
      }
    }
  }

  changeDropDown(data) {
    this.setState({
      list: data
    })
  }
  changeSort(data) {
    this.setState({
      list: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(JSON.stringify(selectedOption))
  }
  handleChangeOperator = (providerId) => {
    this.setState({providerId})
    // alert(JSON.stringify(selectedOption))
  }
  handleChangeOperator = (operatorId) => {
    this.setState({operatorId})
    // alert(JSON.stringify(selectedOption))
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }
  ChangeTimeStampMinDate = (changedTimeStampMin) => {
    this.setState({
      changedTimeStampMin
    })
  }

  ChangeTimeStampMaxDate = (changedTimeStampMax) => {
    this.setState({
      changedTimeStampMax
    })
  }

  showComment = (comment) => {
    if (comment.includes(' ردیف  | ')) {
      return true
    } else {
      return false
    }
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let pageSize = sessionStorage.getItem('dropDownVal')
    let params = sessionStorage.getItem('params')
    const {selectedOption} = this.state
    let reporterName = cookie.load('name')
    let printCol = [
      'ردیف',
      'تامین کننده',
      'تاریخ مقرر',
      'محل تحویل',
      'نام ویزیتور',
      'شماره همراه ویزیتور',
      'وضعیت',
      'توضیحات'
    ]
    let sortParams = [
      {label: 'تاریخ مقرر - صعودی', value: 'initialDeliveryTimeStamp_asc'},
      {label: 'تاریخ مقرر - نزولی', value: 'initialDeliveryTimeStamp_desc'},
      {label: 'وضعیت - نزولی', value: 'orderStatusId_desc'},
      {label: 'وضعیت - صعودی', value: 'orderStatusId_asc'},
      {label: 'تامین کننده - صعودی', value: 'supplierId_asc'},
      {label: 'تامین کننده - نزولی', value: 'supplierId_desc'}
    ]

    return (
      <div className="rtl printA4Page">
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش لیست وضعیت سفارشات.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'supplierName'}
                field={'supplierName'}
                title={'تامین کننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'initialDeliveryTimeStamp'}
                field={'initialDeliveryTimeStamp'}
                title={'تاریخ مقرر'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'orderDeliveryLocationDescription'}
                field={'orderDeliveryLocationDescription'}
                title={'محل تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'visitorName'}
                field={'visitorName'}
                title={'نام ویزیتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'phoneNumber'}
                field={'phoneNumber'}
                title={'شماره همراه ویزیتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'orderStatusDescription'}
                field={'orderStatusDescription'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'orderComment'}
                field={'orderComment'}
                title={'توضیحات'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'paid'}
                field={'invoice.paid'}
                title={'وضعیت پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payOnDelivery'}
                field={'invoice.payOnDelivery'}
                title={'پرداخت در محل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'driver'}
                field={'driver'}
                title={'رساننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'totalInfo.payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'cash'}
                field={'payment.cash'}
                title={'پرداخت نقدی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'card'}
                field={'payment.card'}
                title={'پرداخت کارتخوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'prePaid'}
                field={'payment.prePaid'}
                title={'پرداخت از قبل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست وضعیت سفارشات"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={8}
              rightColSpan={3}
              centerColSpan={1}
              leftColSpan={4}
              centerSection={''}
              rightSection={'تاریخ شروع از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{list.supplierName}</td>
                  <td>{jMoment(list.initialDeliveryTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                  <td>{list.orderDeliveryLocationDescription}</td>
                  <td>{list.visitorName}</td>
                  <td>{list.phoneNumber}</td>
                  <td>
                    <span>{list.orderStatusDescription}</span>
                  </td>
                  <td style={{maxWidth: '250px', minWidth: '150px'}}>{list.orderComment}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>سفارشات</li>
            <li>لیست سفارشات</li>
          </ul>

          <div>
            <div className="tableComponent">
              <div className="tableTools">
                <div className="tableOptionWrapp">
                  <HeaderTable
                    addUrl="orderStatus"
                    printUrl=""
                    printLink=""
                    ChangeDropDown={this.changeDropDown.bind(this)}
                    changeSort={this.changeSort.bind(this)}
                    sort={true}
                    sortParams={sortParams}
                    url={ORDER_STATUS.ORDERS_STATUS_ORDER_VIEW}
                    titleAdd="افزودن سفارش جدید"
                    defaultValuePageSize={'200'}
                  />
                  <button className="filterBtn">
                    <i className="fa fa-search" />
                  </button>
                  <button
                    className={'printButton'}
                    disabled={this.state.buttonClicked ? false : true}
                    onClick={this.exportExcel}
                  >
                    <i className="fas fa-file-excel" />
                  </button>
                  <button
                    className="printButton"
                    disabled={this.state.buttonClicked ? false : true}
                    onClick={this.exportPrint}
                  >
                    <i className="fas fa-print" />
                  </button>
                </div>
              </div>
              <div className="basketFilterComponent">
                <div className="filterInputs">
                  <FromToPicker
                    onChangeFromDate={this.handleChangeFromDate}
                    onChangeToDate={this.handleChangeToDate}
                    fromLabel="تاریخ مقرر از"
                    toLabel="تاریخ مقرر تا"
                    defaulValue={this.state.defaultValueDate}
                    fromId="from"
                    toId="to"
                  />
                  <FromToPicker
                    onChangeFromDate={this.ChangeTimeStampMinDate}
                    onChangeToDate={this.ChangeTimeStampMaxDate}
                    fromLabel="تاریخ ثبت اولیه از"
                    toLabel="تاریخ ثبت اولیه تا"
                    fromId="from"
                    toId="to"
                  />
                  <div className="formComponent selectComponent">
                    <AutoComplete
                      label="تامین کننده"
                      api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                      textField="title"
                      valueField="providerId"
                      id="provider"
                      value={this.state.providerId}
                      setValue={(providerId) => this.setState({providerId})}
                    />
                    {/* <label>تامین کننده :</label>
                                        <Select
                                            value={selectedOption}
                                            onChange={this.handleChange}
                                            options={this.state.providers}
                                            isMulti={false}
                                            isClearable={true}
                                            placeholder={''}
                                            id="providerFilter"
                                            name="providerFilter"
                                            tabIndex='1'
                                        /> */}
                  </div>
                  <div className="formComponent">
                    <label>اپراتور ثبت کننده :</label>
                    <Select
                      value={this.state.operatorId}
                      onChange={this.handleChangeOperator}
                      options={this.state.operators}
                      isClearable={true}
                      placeholder={''}
                    />
                  </div>
                  <div className="formComponent">
                    <label>محل تحویل</label>
                    <select className="form-control" id="locationIdFilter" name="input_orderDeliveryLocationId">
                      <option value={''}>-------</option>

                      {this.state.location.map((loc, index) => (
                        <option key={index} value={loc.deliveryLocationId}>
                          {loc.deliveryLocationName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="formComponent">
                    <label>وضعیت</label>
                    <select className={'form-control'} name="statusFilter" id="orderStatusId">
                      <option value="">-------</option>
                      {this.state.orderStatus.map((orderStatus, index) => (
                        <option key={index} value={orderStatus.orderStatusId}>
                          {orderStatus.orderStatusName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="formComponent">
                    <label>رفتار تحویل</label>
                    <select className={'form-control'} name="deliveryBehaviourId" id="deliveryBehaviourId">
                      <option value="">-------</option>
                      {this.state.deliveryBehaviours.map((orderStatus, index) => (
                        <option key={index} value={orderStatus.deliveryBehaviourId}>
                          {orderStatus.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="formComponent">
                    <label>نام ویزیتور</label>
                    <input className="form-control" id="visitorNameFilter" type="text" />
                  </div>
                  <div className="formComponent">
                    <label>شماره همراه ویزیتور</label>
                    <input className="form-control" id="mobileFilter" type="number" />
                  </div>

                  <div className="formComponent">
                    <label>توضیحات</label>
                    <input className="form-control" id="description" type="text" />
                  </div>

                  <div className="formComponent">
                    <div className="form-control border-0">
                      <Checkbox
                        className="mt-4"
                        checked={this.state.detailSort}
                        onChange={() => this.setState({detailSort: !this.state.detailSort})}
                      >
                        مرتب سازی جزییات
                      </Checkbox>
                    </div>
                  </div>
                </div>
                <div className="filterOption">
                  <button className="confirmFilter" onClick={this.filter.bind(this)}>
                    جست و جو
                  </button>
                </div>
              </div>
              <div className="showBaseTable" style={this.state.showTable ? {display: 'block'} : {display: 'none'}}>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>تامین کننده</td>
                      <td>تاریخ مقرر</td>
                      <td>محل تحویل</td>
                      <td>نام ویزیتور</td>
                      <td>شماره همراه ویزیتور</td>
                      <td>وضعیت</td>
                      <td style={{maxWidth: '250px', minWidth: '150px'}}>توضیحات</td>
                      <td>ویرایش</td>
                      <td>جزییات</td>
                    </tr>
                    {this.state.list.map((list, index) => (
                      <tr key={index}>
                        <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                        <td>{list.supplierId + ' - ' + list.supplierName}</td>
                        <td>{jMoment(list.initialDeliveryTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                        <td>{list.orderDeliveryLocationDescription}</td>
                        <td>{list.visitorName}</td>
                        <td>{list.phoneNumber}</td>
                        <td style={{backgroundColor: list.orderStatusColor}}>
                          <span style={{color: '#fff', fontWeight: '600'}}>{list.orderStatusDescription}</span>
                        </td>
                        <td
                          className="text-left"
                          style={{
                            maxWidth: '250px',
                            minWidth: '150px',
                            whiteSpace: 'pre-line'
                          }}
                        >
                          {list.orderComment !== null &&
                            (this.showComment(list.orderComment) ? (
                              <pre className="d-block" style={{fontSize: '1.2em'}}>
                                {list.orderComment}
                              </pre>
                            ) : (
                              <span className="d-block" style={{fontSize: '1.2em'}}>
                                {list.orderComment}
                              </span>
                            ))}
                        </td>
                        <td>
                          <button onClick={() => this.Edit(index)}>
                            <img
                              style={
                                list.orderStatusDescription == 'کنسلی کامل' ? {display: 'none'} : {display: 'block'}
                              }
                              src={require('../../image/editDriver.svg')}
                              alt=""
                            />
                          </button>
                        </td>
                        <td>
                          <button className="details" onClick={() => this.showDetails(list.orderId)}>
                            <img src={require('../../image/details.svg')} alt="" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="paginationWrapp">
                  <Page
                    defaultCurrent={1}
                    total={this.state.lengthList}
                    onResultFetched={this.onResultFetched.bind(this)}
                    url={ORDER_STATUS.ORDERS_STATUS_ORDER_VIEW}
                    urlParams={params}
                  />
                </div>
              </div>
            </div>
            <Modal isOpen={this.state.modalEdit} toggle={this.EditCancel} size="lg">
              <ModalHeader toggle={this.EditCancel}>ویرایش سفارش</ModalHeader>
              <ModalBody>
                <form className="modalForm editWareForm editOrderModalForm">
                  <figure>
                    <label>وضعیت : </label>
                    <select className={'form-control'} name="input_orderStatusId" id="input_orderStatusId">
                      <option value="">-------</option>
                      {this.state.orderStatus
                        .filter(
                          (item) => item.orderStatusId !== 1 && item.orderStatusId !== 2 && item.orderStatusId !== 3
                        )
                        .map((orderStatus, index) => (
                          <option
                            key={index}
                            value={orderStatus.orderStatusId}
                            selected={
                              orderStatus.orderStatusId === Number(sessionStorage.getItem('intOrderStatusIdDto'))
                                ? true
                                : false
                            }
                          >
                            {orderStatus.orderStatusName}
                          </option>
                        ))}
                    </select>
                  </figure>

                  <figure id="description">
                    <label>توضیحات : </label>
                    <textarea
                      style={{
                        fontSize: '0.9em',
                        minWidth: '325px !important'
                      }}
                      className={'form-control'}
                      name="input_comment"
                      id="input_comment"
                      defaultValue={
                        sessionStorage.getItem('commentDto') == '' ? '' : sessionStorage.getItem('commentDto')
                      }
                    />
                  </figure>

                  <figure>
                    <label>محل تحویل : </label>
                    <select
                      className="form-control"
                      id="input_orderDeliveryLocationId"
                      name="input_orderDeliveryLocationId"
                    >
                      <option value={''}>-------</option>

                      {this.state.location.map((loc, index) => (
                        <option
                          key={index}
                          selected={
                            loc.deliveryLocationId == sessionStorage.getItem('intOrderDeliveryLocationIdDto')
                              ? true
                              : false
                          }
                          value={loc.deliveryLocationId}
                        >
                          {loc.deliveryLocationName}
                        </option>
                      ))}
                    </select>
                  </figure>

                  <figure>
                    <label>نام ویزیتور : </label>
                    <input
                      type={'text'}
                      className={'form-control'}
                      name="input_visitorName"
                      id="input_visitorName"
                      defaultValue={sessionStorage.getItem('visitorNameDto')}
                    />
                  </figure>
                  <figure>
                    <label>شماره همراه ویزیتور : </label>
                    <input
                      type={'text'}
                      className={'form-control'}
                      id="input_visitorPhone"
                      name="input_visitorPhone"
                      defaultValue={sessionStorage.getItem('visitorPhoneDto')}
                    />
                  </figure>
                </form>
              </ModalBody>
              <ModalFooter>
                <button className="cancelBtnModal" onClick={this.EditCancel}>
                  لغو
                </button>{' '}
                <button className="confirmBtnModal" onClick={this.EditOk.bind(this)}>
                  ویرایش سفارش
                </button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.modalDetails} toggle={this.details} size="lg">
              <ModalHeader toggle={this.details}>لیست تغییرات اعمال شده در سفارش</ModalHeader>
              <ModalBody>
                <div style={{overflowX: 'scroll'}}>
                  <table
                    className="baseTable"
                    style={this.state.detailsList.length == '0' ? {display: 'none'} : {diplay: 'block'}}
                  >
                    <tbody>
                      <tr className="firstRow">
                        <td>ردیف</td>
                        <td>وضعیت</td>
                        <td>نام و نام خانوادگی</td>
                        <td>توضیحات</td>
                        <td>تاریخ تغییر</td>
                      </tr>
                      {this.state.detailsList.map((change, index) => (
                        <tr key={index + 'det'}>
                          <td>{index + 1}</td>
                          <td>{change.orderStatusName}</td>
                          <td>
                            {change.operatorFirstName + ' ' + change.operatorLastName}{' '}
                            {change.logicallyDeleted ? '(کاربر حذف شده)' : ''}
                          </td>
                          <td className="text-left" style={{fontSize: '1.2em'}}>
                            {change.orderComment !== null &&
                              (this.showComment(change.orderComment) ? (
                                <pre className="d-block" style={{fontSize: '1.2em'}}>
                                  {change.orderComment}
                                </pre>
                              ) : (
                                <span className="d-block" style={{fontSize: '1.2em'}}>
                                  {change.orderComment}
                                </span>
                              ))}
                          </td>
                          <td>{jMoment(change.changedTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div id="errorEdit">در این سفارش تغییری ایجاد نشده است</div>
              </ModalBody>
              <ModalFooter>
                <button className="cancelBtnModal" onClick={this.closeDetails}>
                  بستن
                </button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    )
  }
}

export default OrderList
